import iconv from 'iconv-lite';
import { verifyToken } from './jwt';
import Cookies from 'js-cookie';
import { doLogout } from '@/Auth/sagas';

export interface IFetchResponse {
    body: any;
    headers: Headers;
    status: number;
}

export async function fetchUtility(url: string, init?: RequestInit): Promise<IFetchResponse> {
    const token: string = Cookies.get('token');

    const headers: any = init && init.headers ? { ...init.headers } : {};

    if (token) {
        try {
            await verifyToken(token);
        } catch (e: any) {
            switch (e.name) {
                case 'JWTExpired':
                    doLogout();
                    (document as any).location = '/';
            }

            throw e;
        }

        headers['Authorization'] = `Bearer ${token}`;
    }

    headers['Accept'] = 'application/json';
    if (!headers['Content-Type']) {
        headers['Content-Type'] = 'application/json';
    }

    return fetch(`${process.env.API_HOST}${url}`, {
        ...init,
        headers,
    }).then((response: Response): Promise<any> => {
        return response.json().then((jsonResponse: any) => {
            return {
                body: jsonResponse,
                headers: response.headers,
                status: response.status,
            };
        });
    });
}

export async function fetchDeleteUtility(url: string): Promise<IFetchResponse> {
    return fetchUtility(url, {
        method: 'DELETE',

    });
}

export async function fetchGetUtility(url: string): Promise<IFetchResponse> {
    return fetchUtility(url, {
        method: 'GET',
    });
}

export async function fetchPostUtility(url: string, body?: any): Promise<IFetchResponse> {
    return fetchUtility(url, {
        body: JSON.stringify(body),
        method: 'POST',
    });
}

export async function fetchPostFileUtility(url: string, body: File): Promise<IFetchResponse> {
    return fetchUtility(url, {
        body,
        headers: {
            'Content-Type': body.type,
            // Convert to ISO 8859-1 to remove unusual characters
            'Filename': iconv.encode(body.name, 'iso-8859-1').toString(),
        },
        method: 'POST',
    });
}

export async function fetchPutUtility(url: string, body?: any): Promise<IFetchResponse> {
    return fetchUtility(url, {
        body: JSON.stringify(body),
        method: 'PUT',
    });
}
